export const getConnectorIcon = (connectorName) => {
    const connector = connectorName?.toLowerCase();
    try {
        return require(`@/assets/img/icons/integrations/${connector}.svg`);
    }
    catch {
        return require(`@/assets/img/icons/integrations/blank.svg`);
    }
};
